import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useNavigate, useLocation } from 'react-router';
import { useTranslations } from '@/i18n/use-translations';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import { useBreakpointDown } from '@/hooks/use-breakpoint';

export default function CreateWizardModal() {
  const t = useTranslations();
  const navigate = useNavigate();
  const location = useLocation();
  const isSmallScreen = useBreakpointDown('md');
  const isCreatePage = location.pathname === '/create';

  const handleCreateClick = () => {
    navigate('/create');
  };

  const commonStyles = isCreatePage
    ? undefined
    : {
        'color': 'action.active',
        'borderColor': 'action.active',
        '&:hover': {
          borderColor: 'action.active',
          backgroundColor: 'action.hover',
        },
      };

  if (isSmallScreen) {
    return (
      <IconButton
        onClick={handleCreateClick}
        sx={{
          ...(commonStyles || {}),
          border: '1px solid',
          borderRadius: 1,
        }}
      >
        <AddOutlinedIcon />
      </IconButton>
    );
  }

  return (
    <Button
      variant="outlined"
      color={isCreatePage ? 'primary' : undefined}
      onClick={handleCreateClick}
      sx={commonStyles}
    >
      {t('common.create')}
      <AddOutlinedIcon sx={{ ml: 0.5 }} />
    </Button>
  );
}
